import { render, staticRenderFns } from "./end-head.vue?vue&type=template&id=21e97565&scoped=true&"
import script from "./end-head.vue?vue&type=script&lang=js&"
export * from "./end-head.vue?vue&type=script&lang=js&"
import style0 from "./end-head.vue?vue&type=style&index=0&id=21e97565&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e97565",
  null
  
)

export default component.exports